<template>
  <WidgetLayout :background-color="backgroundColor" class-name="!pb-4 alt:!p-3">
    <div class="flex gap-8 flex-wrap md:flex-nowrap alt:gap-6">
      <div class="w-full md:basis-[calc(50%-1rem)]">
        <LazyStoreBanner v-bind="leftBanner" banner-style="Half" />
      </div>
      <div class="w-full md:basis-[calc(50%-1rem)]">
        <LazyStoreBanner v-bind="rightBanner" banner-style="Half" />
      </div>
    </div>
  </WidgetLayout>
</template>

<script lang="ts" setup>
import WidgetLayout from '../WidgetLayout.vue'
import type { ButtonStyleOptions, TranslatableString } from '~/types/widgets/widgetTypes'

const { banners, backgroundColor } = defineProps<{
  banners: {
    slug: TranslatableString
    backgroundMobile: TranslatableString
    backgroundDesktop: TranslatableString
    buttonStyle: ButtonStyleOptions[] | ButtonStyleOptions
    buttonText: TranslatableString
    openLinksInNewTab?: boolean
  }[]
  backgroundColor?: string
}>()

const [leftBanner, rightBanner] = banners
</script>
